import { IActionFn } from '@/store/types';
import { IDetail, IModuleState } from './types';
import { sleep } from '@/utils/helper';
import { $http } from '@/axios';
import store from '@/store';
import router from '@/plugins/router';

// 查询过滤项列表
export const queryFilters: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setFilters', { ...state.list, loading: true });
    // const res = await $http.post('/baseinfo/filter/list', payload);
    const res = await $http.post('/v1/baseinfo/filter/list', payload);
    commit('setFilters', { data: res });
  } catch (e) {
    commit('setFilters', { data: [] });
  }
};

// 查询过滤项详情
export const queryFilterDetail: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setFilterDetail', { data: null, loading: true });
    commit('setFilterOptions', { ...state.options, loading: true  });
    // const res: IDetail['data'] = await $http.get(`/baseinfo/filter/detail/${payload}`);
    const res: IDetail['data'] = await $http.get(`/v1/baseinfo/filter/${payload}/detail`);
    commit('setFilterDetail', { data: res });
    commit('setFilterOptions', { data: res?.options || [] });
  } catch (e) {
    commit('setFilterDetail', { data: null });
    commit('setFilterOptions', { data: [] });
  }
};

// 查询可用的属性列表
export const queryFilterProps: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    const entityType = payload.entityType;
    commit('setFilterProps', { data: [], loading: true });
    // const res = await $http.post('/baseinfo/filter/get', payload);
    const res = await $http.get(`/v1/baseinfo/attribute/${entityType}/list`);
    commit('setFilterProps', { data: res });
  } catch (e) {
    commit('setFilterProps', { data: [] });
  }
};

// 查询待挂载列表
export const queryFilterMounts: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setFilterMounts', { data: [], loading: true });
    // const res = await $http.post('/baseinfo/filter/list', payload);
    const res = await $http.post('/v1/baseinfo/filter/list', payload);
    commit('setFilterMounts', { data: res });
  } catch (e) {
    commit('setFilterMounts', { data: [] });
  }
};

// 查询挂载选项列表
export const queryMountOptions: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setMountOptions', { data: [], loading: true });
    // const res = await $http.post('/baseinfo/filter/option/choose', payload);
    const res = await $http.post('/v1/baseinfo/filter/reflist', payload);
    commit('setMountOptions', { data: res });
  } catch (e) {
    commit('setMountOptions', { data: [] });
  }
};

// 添加过滤项
export const addFilter: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/baseinfo/filter/create', payload);
    await $http.post('/v1/baseinfo/filter/create', payload);
    commit('setLoading', false);
    store.commit('common/setToast', { visible: true, text: '添加成功，2秒后跳转到列表页面' });
    await sleep(2);
    await router.push({ name: 'baseinfo-filter' });
  } catch (e) {
    commit('setLoading', false);
  }
};

// 编辑过滤项
export const editFilter: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/baseinfo/filter/update', payload);
    await $http.post('/v1/baseinfo/filter/update', payload);
    store.commit('common/setToast', { visible: true, text: '编辑成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 删除过滤项
export const deleteFilter: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/baseinfo/filter/delete', payload);
    await $http.post('/v1/baseinfo/filter/delete', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 挂载或清空过滤项
export const mountFilter: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/baseinfo/filter/associated', payload);
    await $http.post('/v1/baseinfo/filter/associated', payload);
    const errMsg = payload.code ? '挂载成功' : '清除成功';
    store.commit('common/setToast', { visible: true, text: errMsg });
  } finally {
    commit('setLoading', false);
  }
};

// 编辑选项(暂时没用到)
export const editOption: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/baseinfo/filter/option/modify/name', payload);
  } finally {
    commit('setLoading', false);
  }
};

// 保存选项
export const saveOption: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setSaveLoading', true);
    // await $http.post('/baseinfo/filter/option/update', payload);
    await $http.post('/v1/baseinfo/filter/updateoption', payload);
    store.commit('common/setToast', { visible: true, text: '选项保存成功' });
  } finally {
    commit('setSaveLoading', false);
  }
};
